import { render } from "./ProjectSingle.vue?vue&type=template&id=f0550b88&scoped=true"
import script from "./ProjectSingle.vue?vue&type=script&lang=js"
export * from "./ProjectSingle.vue?vue&type=script&lang=js"

import "./ProjectSingle.vue?vue&type=style&index=0&id=f0550b88&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0550b88"]])

export default __exports__